import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MODAL_AND_DRAWERS_CONSTANTS } from "../consts/modalAndDrawers";
import { CloseIcon } from "../icons/CloseIcon";
import Wallet from "./Shop/Wallet";

const ShopDrawer = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
            document.body.style.overscrollBehavior = "none";
        } else {
            document.body.style.overflow = "";
            document.body.style.overscrollBehavior = "";
        }
        return () => {
            document.body.style.overflow = "";
            document.body.style.overscrollBehavior = "";
        };
    }, [isOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        data-c8-overlay-root="true"
                        data-c8-overlay-dismiss="true"
                        initial={{ opacity: MODAL_AND_DRAWERS_CONSTANTS.initialOpacity }}
                        animate={{ opacity: MODAL_AND_DRAWERS_CONSTANTS.animationOpacity }}
                        exit={{ opacity: MODAL_AND_DRAWERS_CONSTANTS.exitOpacity }}
                        onClick={onClose}
                        className="fixed inset-0 bg-black/70 z-[10000] overflow-hidden touch-none overscroll-none"
                    />

                    {/* Drawer */}
                    <motion.div
                        initial={{ y: "-100%" }}
                        animate={{ y: 0 }}
                        exit={{ y: "-100%" }}
                        transition={{ type: "spring", damping: 25, stiffness: 200 }}
                        id="shopDrawer"
                        data-c8-overlay-root="true"
                        className="fixed top-0 left-0 right-0 z-[10002] flex max-h-[100dvh] w-full max-w-full flex-col overflow-hidden border-b border-white/10 bg-[#4E2681] md:max-h-[calc(100dvh-50px)] lg:max-h-[calc(100dvh-97px)]"
                        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
                    >
                        {/* Header */}
                        <div
                            className="z-10 w-full max-w-full shrink-0 overflow-x-hidden border-t-2 border-blue-500"
                            style={{
                                background: "linear-gradient(88.89deg, #652DAF 0%, #623998 100%)",
                            }}
                        >
                            <div className="c8-shell relative flex items-center justify-center py-3 pl-4 pr-1 md:pl-6 md:pr-1.5">
                                <div className="text-white font-anton text-[16px] md:text-[18px] uppercase leading-none flex items-center py-0">SHOP</div>

                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="absolute right-0.5 top-1/2 flex min-h-11 min-w-11 -translate-y-1/2 items-center justify-center py-0 leading-none text-white transition-colors hover:text-gray-300 md:right-1"
                                    aria-label="Close"
                                >
                                    <CloseIcon size={28} />
                                </button>
                            </div>
                        </div>

                        <div className="min-h-0 w-full max-w-full flex-1 overflow-x-hidden overflow-y-auto overscroll-contain bg-[#401A6E] pb-[max(16px,env(safe-area-inset-bottom,0px))] [-webkit-overflow-scrolling:touch]">
                            <div className="c8-shell">
                                <Wallet />
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default ShopDrawer;
